import {
  SnippetElement,
  defineElement,
  onClick,
  query
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XS5WIYU5.js";

// src/snippets/util-video/util-video.ts
var UtilVideo = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.paused = false;
  }
  connectedCallback() {
    if (this.moduleVideo == null)
      return;
    this.paused = false;
    if (this.moduleVideo.getAttribute("autoplay") === null) {
      this.paused = true;
      if (this.thumbnail != null)
        this.thumbnail.classList.remove("hidden");
      if (this.moduleVideo != null)
        this.moduleVideo.classList.add("hidden");
    } else {
      this.paused = false;
      if (this.thumbnail != null)
        this.thumbnail.classList.add("hidden");
      if (this.moduleVideo != null)
        this.moduleVideo.classList.remove("hidden");
    }
  }
  handleClickPlay() {
    if (this.moduleVideo == null)
      return;
    if (this.moduleVideo.getAttribute("allow_pause") === "true")
      return;
    if (this.paused) {
      console.log("Paused now want to play");
      this.moduleVideo.play();
      if (this.playButton != null)
        this.playButton.classList.add("hidden");
      if (this.thumbnail != null)
        this.thumbnail.classList.add("hidden");
      if (this.moduleVideo != null)
        this.moduleVideo.classList.remove("hidden");
      this.paused = false;
    } else {
      this.moduleVideo.pause();
      if (this.playButton != null)
        this.playButton.classList.remove("hidden");
      if (this.thumbnail != null)
        this.thumbnail.classList.remove("hidden");
      if (this.moduleVideo != null)
        this.moduleVideo.classList.add("hidden");
      this.paused = true;
    }
  }
  handleClickMute() {
    var _a, _b, _c, _d;
    if (this.moduleVideo == null)
      return;
    if (this.moduleVideo.muted) {
      this.moduleVideo.muted = false;
      (_a = this.mutedIcon) == null ? void 0 : _a.classList.add("hidden");
      (_b = this.unmutedIcon) == null ? void 0 : _b.classList.remove("hidden");
    } else {
      this.moduleVideo.muted = true;
      (_c = this.mutedIcon) == null ? void 0 : _c.classList.remove("hidden");
      (_d = this.unmutedIcon) == null ? void 0 : _d.classList.add("hidden");
    }
  }
};
__decorateClass([
  query("video")
], UtilVideo.prototype, "moduleVideo", 2);
__decorateClass([
  query("[data-muted]")
], UtilVideo.prototype, "mutedIcon", 2);
__decorateClass([
  query("[data-unmuted]")
], UtilVideo.prototype, "unmutedIcon", 2);
__decorateClass([
  query("[data-play]")
], UtilVideo.prototype, "playButton", 2);
__decorateClass([
  query("[data-thumbnail]")
], UtilVideo.prototype, "thumbnail", 2);
__decorateClass([
  onClick("[data-video-wrapper]")
], UtilVideo.prototype, "handleClickPlay", 1);
__decorateClass([
  onClick("[data-mute]")
], UtilVideo.prototype, "handleClickMute", 1);
UtilVideo = __decorateClass([
  defineElement("util-video")
], UtilVideo);
export {
  UtilVideo
};
